import BirthdayService from '@src/services/birthday.services.js'
import { fullName } from '@utils/generalUtil'

export default {
  async fetchBirthdays({ commit }, payload) {
    commit('SET_LOADING', true)
    try {
      const response = await BirthdayService.fetchBirthdays(payload)
      const birthdays = fullName(response?.data?.records || [])
      return birthdays
    } catch (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
      throw error
    }
  },
}
